import { RootState } from "../../../../redux/store";
import { useSelector } from "react-redux";
import {
  Slider,
  SliderButton,
  SliderButtonPropsDirection,
  SliderButtonsWrapper,
  SliderHeaderWrapper,
  SliderHeaderWrapperContainer,
  SliderSubtitle,
  SliderTitleBold,
  SliderWrapper,
} from "../../../global/sliders";
import { MaterialCard } from "../../../explore/material/cards/MaterialCard";
import { SwiperSlide } from "swiper/react";

export const ListingSimilarListingsSection = () => {
  const listingsRedux = useSelector(
    (state: RootState) => state.trainingPlan.similarListings,
  );
  const trainingPlanRedux = useSelector(
    (state: RootState) => state.trainingPlan.listingData,
  );
  const filteredListings = listingsRedux?.rows.filter(
    (item) => item.id !== trainingPlanRedux.id,
  );
  const similarListingSwiperId = "similar-listings";

  if (filteredListings.length > 0) {
    return (
      <SliderWrapper>
        <SliderHeaderWrapper>
          <SliderHeaderWrapperContainer>
            <SliderTitleBold>Similar training plans</SliderTitleBold>
            <SliderSubtitle>Train like a pro</SliderSubtitle>
          </SliderHeaderWrapperContainer>

          <SliderButtonsWrapper>
            <SliderButton
              id={similarListingSwiperId}
              middlePosition={true}
              direction={SliderButtonPropsDirection.LEFT}
            />
            <SliderButton
              id={similarListingSwiperId}
              middlePosition={true}
              direction={SliderButtonPropsDirection.RIGHT}
            />
          </SliderButtonsWrapper>
        </SliderHeaderWrapper>

        <Slider customSwiperId={similarListingSwiperId}>
          {filteredListings.map((filteredListing) => (
            <SwiperSlide key={filteredListing.id}>
              <MaterialCard data={filteredListing} />
            </SwiperSlide>
          ))}
        </Slider>
      </SliderWrapper>
    );
  }
};
